import { render, staticRenderFns } from "./arvioitavan-kokonaisuuden-kategoria.vue?vue&type=template&id=1eb8a17d&scoped=true&"
import script from "./arvioitavan-kokonaisuuden-kategoria.vue?vue&type=script&lang=ts&"
export * from "./arvioitavan-kokonaisuuden-kategoria.vue?vue&type=script&lang=ts&"
import style0 from "./arvioitavan-kokonaisuuden-kategoria.vue?vue&type=style&index=0&id=1eb8a17d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb8a17d",
  null
  
)

export default component.exports